/**
 * A reusable toggle Component
 */
import React from 'react';
import { ToggleContainer } from './Toggle.styled';
import { OnOffBall } from '../index';
function ToggleInput(_a) {
    var _b = _a.width, width = _b === void 0 ? '50px' : _b, _c = _a.height, height = _c === void 0 ? '30px' : _c, _d = _a.isOn, isOn = _d === void 0 ? false : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.onClick, onClick = _f === void 0 ? function (e) {
        e.preventDefault();
    } : _f;
    return (React.createElement(ToggleContainer, { width: width, height: height, disabled: disabled, isOn: isOn, onClick: disabled ? function () { } : onClick }, isOn ? React.createElement(OnOffBall, { variant: "on" }) : React.createElement(OnOffBall, { variant: "off" })));
}
export default ToggleInput;
